<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="省" prop="provinceId">
        <el-select v-model="searchData.provinceId" placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityId">
        <el-select v-model="searchData.cityId" placeholder="请选择" clearable style="width: 100%" :disabled="!searchData.provinceId" @change="cityChangeFun">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyId">
        <el-select v-model="searchData.countyId" placeholder="请选择" clearable style="width: 100%" :disabled="!searchData.cityId">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" :loading="exportLoadFlag" @click="exportBtnFun">导出</el-button>
        <el-button type="primary" size="medium" @click="batchRecycleBtnFun">批量回收</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh" @selection-change="selectChangeFun">
      <el-table-column type="selection" :selectable="selectableFun" width="55"> </el-table-column>
      <el-table-column label="操作" prop="action" width="160">
        <template slot-scope="scope">
          <el-link v-if="scope.row.waitCount != 0" type="primary" @click="recycleDetFun(scope.row)">待回收明细</el-link>
          <el-link v-if="scope.row.waitCount != 0" style="margin-left: 12px;" type="primary" @click="rowRecycleFun(scope.row)">回收</el-link>
        </template>
      </el-table-column>
      <el-table-column label="省份" prop="province" min-width="100"></el-table-column>
      <el-table-column label="城市" prop="city" min-width="100"></el-table-column>
      <el-table-column label="区/县" prop="county" min-width="100"></el-table-column>
      <el-table-column label="可回收总数" prop="waitCount" min-width="120"></el-table-column>
      <el-table-column label="回收中总数" prop="recyclingCount" min-width="120"></el-table-column>
      <el-table-column label="已回收总数" prop="alreadyCount" min-width="120"></el-table-column>
      <el-table-column label="丢失数量" prop="lostCount" width="100"></el-table-column>
      <el-table-column label="更新时间" prop="lastModifiedDate" min-width="120"></el-table-column>
      <el-table-column label="上次回收完成时间" prop="lastCompletedDate" min-width="120"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <RecycleConfirmDialog ref="recycleConfirmDialogRef" @confirm-recycle="batchRecycleFun"></RecycleConfirmDialog>
    <PlaceOrderDialog ref="placeOrderDialogRef" @opera-success="recycleSuccessFun"></PlaceOrderDialog>
  </div>
</template>
<script>
import RecycleConfirmDialog from './components/RecycleConfirmDialog.vue'
import PlaceOrderDialog from './components/PlaceOrderDialog.vue'
import jdProvinceCity from './mixins/jdProvinceCity.js'
export default {
  components: {
    RecycleConfirmDialog,
    PlaceOrderDialog
  },
  mixins: [jdProvinceCity],
  data() {
    return {
      searchData: {
        provinceId: undefined,
        cityId: undefined,
        countyId: undefined
      },
      exportLoadFlag: false,
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        size: 10
      },
      total: 0,
      selectList: [],
      provinceList: [],
      cityList: []
    }
  },
  created() {
    this.handleSearch()
    this.getTblProvinceNew()
  },
  methods: {
    // 省改变
    provinceChangeFun() {
      this.searchData.cityId = undefined
      this.searchData.countyId = undefined
      const provinceId = this.searchData.provinceId
      this.getTblCityNew(provinceId)
    },

    // 市改变
    cityChangeFun() {
      this.searchData.countyId = undefined
      const provinceId = this.searchData.provinceId
      const cityId = this.searchData.cityId
      this.getTblCountyNew(provinceId, cityId)
    },
    // 获取库存分页
    getList() {
      const url = `/autoapp-default-server-recovery/api/jd/recycle/city/station/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      return this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          this.total = res.total || 0
          const resData = res.data || []
          this.tableData = resData
        }
      })
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      this.searchData = {
        provinceId: undefined,
        cityId: undefined
      }
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 选择改变
    selectChangeFun(selection) {
      this.selectList = selection
    },
    selectableFun(row) {
      return row.waitCount > 0
    },
    // 批量创建回收
    batchRecycleBtnFun() {
      if (this.selectList.length == 0) {
        this.$message.warning('请先选择数据')
        return
      }
      this.$refs.recycleConfirmDialogRef.opendDialog(2)
    },
    // 确认批量回收
    batchRecycleFun() {
      const idList = this.selectList.map(item => item.id)
      const params = {
        idList
      }
      const url = `/autoapp-default-server-recovery/api/jd/recycle/saveBatchRecycleCity`
      return this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('批量回收成功')
          this.recycleSuccessFun()
          return
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 导出
    exportBtnFun() {
      this.exportLoadFlag = true
      setTimeout(() => {
        this.exportLoadFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/city/station/exportPageCondition'
      const title = '京东旧机库存列表（城市）'
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      // this.global.exportExcel(url, params, title).catch(res => {
      //   let blob = new Blob([res.response.data], {
      //     type: 'application/json'
      //   })
      //   var blobReader = new Response(blob).json()
      //   blobReader.then(res => {
      //     this.$message.error(res.message)
      //   })
      // })
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 待回收明细
    recycleDetFun(rowData) {
      // 跳转到京东旧机明细页,仓库编号为对应仓库编号、旧机状态为待回收
      let { stationId, cityId, provinceId, countyId } = rowData
      cityId ? parseInt(cityId) : undefined
      provinceId ? parseInt(provinceId) : undefined
      countyId ? parseInt(countyId) : undefined
      const stationIds = stationId ? [stationId] : undefined
      const cityIds = cityId ? [cityId] : undefined
      const provinceIds = provinceId ? [provinceId] : undefined
      const countyIds = countyId ? [countyId] : undefined

      const toPageParams = {
        oldMachineStatus: '100', // 待回收
        stationIds: stationIds,
        cityIds: cityIds,
        provinceIds: provinceIds,
        countyIds: countyIds
      }
      this.$router.push({
        path: '/jdOldMachineRecycleManage/jdOldMachineSearch',
        query: {
          ...toPageParams
        }
      })
    },
    // 回收
    rowRecycleFun(rowData) {
      this.$refs.placeOrderDialogRef.opendDialog(rowData)
    },
    // 回收成功
    recycleSuccessFun() {
      this.handleSearch()
    }
  }
}
</script>
<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/jdOldMachineInventCity.vue